import { GetOneCustomerInDto, GetOneCustomerOutDto } from '../../../types/customer.dto'

export const DOWNLOAD_CUSTOMER = 'DOWNLOAD_CUSTOMER'
export const DOWNLOAD_CUSTOMER_SUCCESS = 'DOWNLOAD_CUSTOMER_SUCCESS'
export const DOWNLOAD_CUSTOMER_ERROR = 'DOWNLOAD_CUSTOMER_ERROR'
export const RESET_DOWNLOAD_CUSTOMER = 'RESET_DOWNLOAD_CUSTOMER'

export interface DownloadCustomer {
    type: typeof DOWNLOAD_CUSTOMER
    payload: GetOneCustomerOutDto
}

export interface DownloadCustomerSuccess {
    type: typeof DOWNLOAD_CUSTOMER_SUCCESS
    payload: GetOneCustomerInDto
}

export interface DownloadCustomerError {
    type: typeof DOWNLOAD_CUSTOMER_ERROR
    payload: string | boolean
}

export interface ResetDownloadCustomer {
    type: typeof RESET_DOWNLOAD_CUSTOMER
    payload: null
}

export interface State {
    data: GetOneCustomerInDto | null
    states: {
        loading: boolean
        success: boolean
        error: boolean | string
    }
}

export const initialState: State = {
    data: null,
    states: {
        loading: false,
        success: false,
        error: false,
    },
}

export type Actions = DownloadCustomer | DownloadCustomerSuccess | DownloadCustomerError | ResetDownloadCustomer